import { Component } from '@angular/core';

import { ButtonModule } from 'primeng/button';
import { RippleModule } from 'primeng/ripple';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';

export enum ApproveDialogType {
  Delete = 'Delete',
  Add = 'Add',
  Save = 'Save',
}
export interface ApproveDialogData {
  approvalQuestion?: string;
  cancelBtnText?: string;
  approveBtnText?: string;
  type?: ApproveDialogType;
}
@Component({
  selector: 'app-approve-dialog',
  standalone: true,
  imports: [ButtonModule, RippleModule],
  templateUrl: './approve-dialog.component.html',
  styleUrl: './approve-dialog.component.scss',
})
export class ApproveDialogComponent {
  public ApproveDialogType = ApproveDialogType;
  public dialogData: ApproveDialogData;

  constructor(
    private dialogRef: DynamicDialogRef,
    private config: DynamicDialogConfig
  ) {
    this.dialogData = this.config.data;
  }

  public closeDialog() {
    this.dialogRef.close();
  }
}
